"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDisplayName = exports.medicalWords = exports.termsAndConditions = exports.EPlatformId = exports.FCM_TOPICS = exports.EGrammarType = exports.AlgoliaIndex = exports.ERRORS = exports.utils = exports.Models = void 0;
const random_1 = require("./utils/random");
exports.Models = __importStar(require("./models"));
__exportStar(require("./resolvers"), exports);
exports.utils = __importStar(require("./utils"));
exports.ERRORS = {
    TOKEN_INVALID: 'Invalid token.',
    TOKEN_MISSING: 'Missing token.',
    TOKEN_EXPIRED: 'Expired token.',
    SUBSCRIPTION_EXPIRED: 'Expired subscription.',
    PERMISSION_INVALID: 'Invalid permission.',
    SESSION_MISSING: 'No Session Found, Please login again',
};
var AlgoliaIndex;
(function (AlgoliaIndex) {
    AlgoliaIndex["Questions"] = "questions";
    AlgoliaIndex["Flashcards"] = "cards";
    AlgoliaIndex["Quesbook"] = "quesbook";
    AlgoliaIndex["OsceBook"] = "oscebook";
    AlgoliaIndex["Videos"] = "videos";
})(AlgoliaIndex = exports.AlgoliaIndex || (exports.AlgoliaIndex = {}));
var EGrammarType;
(function (EGrammarType) {
    EGrammarType[EGrammarType["QUESTION"] = 0] = "QUESTION";
    EGrammarType[EGrammarType["CARD"] = 1] = "CARD";
    EGrammarType[EGrammarType["CONCEPT"] = 2] = "CONCEPT";
    EGrammarType[EGrammarType["PSA_MULTI_QA"] = 3] = "PSA_MULTI_QA";
    EGrammarType[EGrammarType["PSA_PRESCRIBE"] = 4] = "PSA_PRESCRIBE";
    EGrammarType[EGrammarType["PSA_QA"] = 5] = "PSA_QA";
    EGrammarType[EGrammarType["PSA_SBA"] = 6] = "PSA_SBA";
    EGrammarType[EGrammarType["OSCE"] = 7] = "OSCE";
    EGrammarType[EGrammarType["BOOK"] = 8] = "BOOK";
    EGrammarType[EGrammarType["EMQ_QUESTION"] = 9] = "EMQ_QUESTION";
    EGrammarType[EGrammarType["SJT_QUESTION"] = 10] = "SJT_QUESTION";
    EGrammarType[EGrammarType["RA_QUESTION"] = 11] = "RA_QUESTION";
    EGrammarType[EGrammarType["PACES"] = 12] = "PACES";
    EGrammarType[EGrammarType["PACE_TEMPLATE"] = 13] = "PACE_TEMPLATE";
    EGrammarType[EGrammarType["QUESTION_STEM"] = 14] = "QUESTION_STEM";
    EGrammarType[EGrammarType["VERBAL_VERACITY"] = 15] = "VERBAL_VERACITY";
    EGrammarType[EGrammarType["VERBAL_READING_COMPREHENSION"] = 16] = "VERBAL_READING_COMPREHENSION";
    EGrammarType[EGrammarType["QUANTITATIVE_REASONING_SBA"] = 17] = "QUANTITATIVE_REASONING_SBA";
    EGrammarType[EGrammarType["DECISION_MAKING_SBA"] = 18] = "DECISION_MAKING_SBA";
    EGrammarType[EGrammarType["DECISION_MAKING_YES_NO"] = 19] = "DECISION_MAKING_YES_NO";
    EGrammarType[EGrammarType["SJT_SINGLE_CHOICE"] = 20] = "SJT_SINGLE_CHOICE";
    EGrammarType[EGrammarType["SJT_TWO_ANSWERS"] = 21] = "SJT_TWO_ANSWERS";
})(EGrammarType = exports.EGrammarType || (exports.EGrammarType = {}));
exports.FCM_TOPICS = {
    GLOBAL: 'global',
    QBANK: 'qbank',
    OSCE: 'osce',
};
var EPlatformId;
(function (EPlatformId) {
    EPlatformId[EPlatformId["QBANK"] = 0] = "QBANK";
    EPlatformId[EPlatformId["OSCE"] = 1] = "OSCE";
})(EPlatformId = exports.EPlatformId || (exports.EPlatformId = {}));
exports.termsAndConditions = `# Group Study Conduct Policy

As future clinicians, we expect that you treat your colleagues fairly and with respect.
As a result, we will not tolerate the following actions during use of the Quesmed platform:

- Violent threats
- Wishing, hoping or calling for serious harm on a person or group of people
- Incitement against individuals or groups
- Slurs, racist and sexist tropes
- Degrading others
- Unwanted sexual advances

When determining the penalty for violating our conduct policy, we consider a number of factors including the severity of the violation and the individual's record of violations. We reserve the right to immediately de-activate any account that violates our conduct policy. We may also consider raising concerns to the individual's licensing body (e.g. GMC) on a case-by-case basis.

By using the platform, you agree to be bound by our conduct policy as described above.`;
exports.medicalWords = [
    ['Abrasion', 'Abscess', 'Acute', 'Amnesia', 'Anterior', 'Axillary'],
    ['Benign', 'Biopsy', 'Botox', 'Bladder', 'Body', 'Bradykinin'],
    ['Chronic', 'Contusion', 'Cystic', 'Complement', 'CT'],
    ['Defibrillator', 'Dermis', 'DNA', 'Dorsal', 'Dominant'],
    ['Edema', 'Embolism', 'Epidermis', 'Endoscope'],
    ['Fracture', 'Fibrillation', 'Flutter', 'Fever', 'Fungal', 'Fibrosis'],
    ['Gland', 'Gastro', 'Gas', 'Gallbladder'],
    ['Hypertension', 'Hematoma', 'Haemophilus', 'Hallux', 'Hereditary'],
    ['Inpatient', 'Intravenous', 'Intubation'],
    ['JAK', 'Juice', 'Jargon', 'Jaundice'],
    ['Kinin', 'Ketone', 'Kawasaki', 'Kinase'],
    ['Lung', 'Liver', 'Lymph', 'Loose', 'Lumbar', 'Lateral'],
    ['Monoclonal', 'Myopathy', 'Myotonia', 'Metabolism', 'Migraine'],
    ['Neoplasia', 'NICU', 'Nightshift'],
    ['Outpatient', 'Osteoporosis', 'Otitis', 'Odor'],
    ['Prognosis', 'Power', 'Poisoning', 'Pudendal', 'Polyps', 'Prone'],
    ['QRS', 'Qwave', 'Quaternary'],
    ['Relapse', 'Rhinoplasty', 'Retrograde', 'RNA', 'Recessive'],
    [
        'Suture',
        'Serotonin',
        'Sclerosis',
        'Stasis',
        'Serpiginous',
        'Syndrome',
        'Supine',
    ],
    [
        'Transplant',
        'Thermoregulator',
        'Tyrosine',
        'Tachycardia',
        'Tazocin',
        'Tanoy',
    ],
    ['Uveitis', 'Uremic', 'Urology', 'Upright', 'Uwave'],
    ['Viral', 'Vaccine', 'Vitamin', 'Versicolor', 'Ventral'],
    ['Wilsons', 'WBC', 'Womb'],
    ['X-ray', 'Xeno', 'X-linked'],
    ['Yellow', 'Yersinia', 'Yeast'],
    ['Zika', 'Zebras', 'Zygomatic', 'Z-line'],
];
function generateDisplayName(firstName, lastName) {
    let firstNameChar = firstName.toLowerCase().charCodeAt(0) - 97;
    if (isNaN(firstNameChar) || firstNameChar > 25 || firstNameChar < 0) {
        firstNameChar = Math.round(Math.random() * 25);
    }
    let lastNameChar = lastName.toLowerCase().charCodeAt(0) - 97 || Math.round(Math.random() * 25);
    if (isNaN(lastNameChar) || lastNameChar > 25 || lastNameChar < 0) {
        lastNameChar = Math.round(Math.random() * 25);
    }
    let displayName;
    const medWordsFirstName = (0, random_1.getRandom)(exports.medicalWords[firstNameChar], 2);
    if (firstNameChar === lastNameChar) {
        displayName = `${medWordsFirstName[0]} ${medWordsFirstName[1]}`;
    }
    else {
        displayName = `${medWordsFirstName[0]} ${(0, random_1.getRandom)(exports.medicalWords[lastNameChar], 1)[0]}`;
    }
    return displayName;
}
exports.generateDisplayName = generateDisplayName;
